import {
  calculateLinePaths,
  calculateVerticalScale,
} from "wavesurfer.js/dist/renderer-utils.js"

/** Draw into the waveform band, reserving the remainder of each channel for caller content. */
export function renderSpeakerWaveform(
  waveformHeight: number,
  channelHeight: number,
) {
  return (
    channelData: Array<Float32Array | number[]>,
    context: CanvasRenderingContext2D,
  ) => {
    const height = (context.canvas.height * waveformHeight) / channelHeight
    const paths = calculateLinePaths({
      channelData,
      width: context.canvas.width,
      height,
      vScale: calculateVerticalScale({ channelData, normalize: true }),
    })
    context.beginPath()
    for (const path of paths) {
      if (!path.length) {
        continue
      }
      context.moveTo(path[0].x, path[0].y)
      for (const point of path.slice(1)) {
        context.lineTo(point.x, point.y)
      }
    }
    context.fill()
    context.closePath()
  }
}
